import {worktimetrackingApiType} from "./worktimetrackingApi.interface";
import {requests} from "../../../../@WUM/core/RestFullApi/api";
import {clockTimingInterface, clockTrackingDataInterface} from "./clockTimingInterface";
import {
    NotificationSettingsInterface,
    SettingsInterface,
    UserOptions,
    VacationDashboardWidgetInterface
} from "./settingsworktimetrackingInterface";

export const worktimetracking = {
    getPosts: (id:any): Promise<worktimetrackingApiType[]> =>
        requests.get(`work/timetracking/${id}/`),
    getPostsTimeSheet: (id:any,date:any): Promise<worktimetrackingApiType[]> =>
        requests.get(`work/timetracking/timesheet/${id}/${date}/`),
    getPostsPlaner: (): Promise<worktimetrackingApiType[]> =>
        requests.get(`work/planer/`),
    updatePost: (post: any, id: number): Promise<worktimetrackingApiType> =>
        requests.put(`User/update/${id}/`, post),
    deletePost: (id: any): Promise<void> =>
        requests.delete(`User/delete/${id}/`),
    startWork: (): Promise<clockTimingInterface> =>
        requests.get('timeTracking/yoptimize/start/work/'),
    stopWork: (): Promise<clockTimingInterface> =>
        requests.get('timeTracking/yoptimize/stop/work/'),
    startBreak: (): Promise<clockTimingInterface> =>
        requests.get(`timeTracking/yoptimize/start/pause/`),
    stopBreak: (): Promise<clockTimingInterface> =>
        requests.get(`timeTracking/yoptimize/stop/pause/`),
    endDay: (): Promise<clockTimingInterface> =>
        requests.get(`timeTracking/yoptimize/working/day/end/`),
    calculatedWorkingDays: (date: string): Promise<clockTrackingDataInterface> =>
        requests.get(`/timeTracking/yoptimize/calculated/working/day/${date}/`),

    settings: (id?: string): Promise<SettingsInterface> =>
        requests.get(`work/timesettings/?id=${id}`),

    autoclock: (id?: string): Promise<SettingsInterface> =>
        requests.get(`work/autoclocksettings/${id ? `?id=${id}` : ""}`),
    autobreak: (id?: string): Promise<SettingsInterface> =>
        requests.get(`work/autobreaksettings/${id ? `?id=${id}` : ""}`),
    notificationSettings: (): Promise<NotificationSettingsInterface> =>
        requests.get('work/notification/settings/'),

    holidayDetailDashboard: (id: string): Promise<VacationDashboardWidgetInterface> =>
        requests.get(`yoptimize/responsibility/vacation/${id}/`),

    employees: (): Promise<UserOptions> =>
        requests.get('company/employees/')
}
